'use strict';

var cleave = require('org/components/cleave');
var formValidation = require('org/components/formValidation');
var storeLocator = require('org/storeLocator/storeLocator');

/**
 * formatting for phone number field
 */
function handlePhoneNumber() {
    if ($('[name$="_hops_phone"]').length > 0) {
        cleave.handlePhoneNumber('[name$="_hops_phone"]', 'US');
    }
}

module.exports = {
    showHOPSDialog: function (dialog) {
        var self = this;
        if ($('#quickViewModal').length !== 0) {
            $('#quickViewModal').modal('hide');
        }
        if ($('#hopsModal').length !== 0) {
            $('#hopsModal').modal('hide');
            $('#hopsModal').replaceWith(dialog);
        } else {
            $('body').append(dialog);
        }
        $('#hopsModal').modal('show');

        if ($('#isStoreLocatorRedesign').length) {
            $('#hopsModal').addClass('hops-modal-redesign');
        }

        handlePhoneNumber();
        storeLocator.checkStoreHours();

        $('#hops-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            $('#hops-form-btn-reserve').attr('disabled', '');

            var url = $form.attr('action');
            var data = $form.serialize();

            $('#hopsModal .modal-content').spinner().start();
            $.ajax({
                type: 'post',
                url: url,
                data: data,
                dataType: 'html'
            }).done(function (content, textStatus, request) {
                var response = request.getResponseHeader('Content-Type');
                if (/json/.test(response)) {
                    response = jQuery.parseJSON(content);
                    if (response.error) {
                        formValidation($form, response);
                    }
                    $('#hops-form-btn-reserve')[0].removeAttribute('disabled', '');
                } else {
                    self.showHOPSResultDialog(content);
                    $('#hopsModal').modal('hide');
                    var gtmData = $('.hops-item', '#hopsResultModal').length > 0 ? $('.hops-item', '#hopsResultModal').eq(0).data('gtm') : null;
                    if (gtmData) {
                        $('body').trigger('hops:AfterRequestSubmit', { gtmData: gtmData });
                    }
                }
            }).always(function () {
                $('#hopsModal .modal-content').spinner().stop();
            });
        });
    },
    showHOPSResultDialog: function (dialog) {
        if ($('#hopsResultModal').length !== 0) {
            $('#hopsResultModal').modal('hide');
            $('#hopsResultModal').replaceWith(dialog);
        } else {
            $('body').append(dialog);
        }
        $('#hopsResultModal').modal('show');
        storeLocator.checkStoreHours();
    }
};
